import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import styles from "./style.module.scss";

const logo = require("../../../images/greek-dressing-logo-no-text.svg");

export default function DefaultNav({ routes }) {
  const createLink = (route, className) => (
    <Link
      className={cx({ [styles.link]: true, [className]: true })}
      to={route.to}
      key={route.title}
    >
      {route.title}
    </Link>
  );

  const Logo = () => (
    <img
      src={logo}
      className={styles.logo}
      alt="Greek Dressing Logo"
      title="Greek Dressing Logo"
    />
  );

  return (
    <div className={styles.menu}>
      <div className={styles.menuItems}>
        {routes.map(route => createLink(route))}
      </div>
      <Link to="/">
        <Logo />
      </Link>
      <div className={styles.menuItems}>
        <a
          className={styles.link}
          href="https://shop.greekdressing.us/collections/all-products"
        >
          Shop Retail
        </a>
        {createLink(
          {
            to: "/new-order",
            title: "Get Started"
          },
          styles.order
        )}
      </div>
    </div>
  );
}

DefaultNav.propTypes = {
  routes: PropTypes.arrayOf(
    PropTypes.shape({
      to: PropTypes.string,
      title: PropTypes.string
    })
  ).isRequired
};
